import React, {useEffect} from 'react';
import './App.css';
import {
    HeaderAndFooterLayout,
} from "./Components/module";
import {Switch} from 'react-router-dom';
import {Provider, useSelector} from "react-redux";
import {ConnectedRouter} from 'connected-react-router';
import Routes from './Components/router';
import {jamboStore} from "./stores/store";
import {history} from './redux/store/index';
import {SnackbarProvider} from "notistack";
import {initCall} from "./stores/base/basethunks";
import {createTheme, ThemeProvider} from '@mui/material/styles';

import AppWrapper from "./Components/Component/AppWrapper";
import axios from "axios";
import {strings} from "./strings";


jamboStore.dispatch(initCall());

const theme = createTheme();

const App = () => {

    return (
        <Provider store={jamboStore}>
            <ConnectedRouter history={history}>
                <AppWrapper>
                    <Switch>
                        <Routes/>
                    </Switch>
                </AppWrapper>
            </ConnectedRouter>
            {/*<ToastContainer />*/}

        </Provider>
    )

}

// export default App;
export default function IntegrationNotistack() {
    return (
        <SnackbarProvider maxSnack={10} anchorOrigin={{vertical: "top", horizontal: "center"}}>
            <App/>
        </SnackbarProvider>
    );
}

